import { render, staticRenderFns } from "./widgetSecAppCtrlCategory.vue?vue&type=template&id=4aa330d3&scoped=true&"
import script from "./widgetSecAppCtrlCategory.vue?vue&type=script&lang=js&"
export * from "./widgetSecAppCtrlCategory.vue?vue&type=script&lang=js&"
import style0 from "./widgetSecAppCtrlCategory.vue?vue&type=style&index=0&id=4aa330d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa330d3",
  null
  
)

export default component.exports